import { GridColDef } from "@mui/x-data-grid";
import { User } from "@sentry/react";
import { TbFavicon } from "react-icons/tb";

import PlateComponent from "@/components/Plate";
import { TableHeader } from "@/components/TableHeader";
import { WeTrackVehicleData } from "@/types/wetrack.types";

export const PlateColumn = <T extends WeTrackVehicleData["properties"] | User>({
    getPlate,
}: {
    getPlate: (row: T) => string;
}): GridColDef<WeTrackVehicleData["properties"]> => {
    return {
        headerName: "plate",
        renderHeader: (params) => <TableHeader Component={TbFavicon} title={params.colDef.headerName!} />,
        field: "plate",
        minWidth: 150,
        valueGetter: (_val, row) => getPlate(row as T),
        filterable: false,
        renderCell: (params) => {
            return (
                <div className="flex items-center h-full">
                    {params.value && <PlateComponent plate={params.value} />}
                </div>
            );
        },
    };
};
